<template>
  <section class="container text-center pb-5 bg-f2">
    <div class="row justify-content-center">
      <div class="col-9">
        <h5 class="mb-3">Informações adicionais</h5>
        <ul class="pb-5">
          <li v-for="(item, ind) in list" :key="ind">
            <span v-html="item" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'InfoComp',
  data() {
    return {
      list: [
        `O Candidato é responsável pela exatidão e veracidade das informações prestadas no requerimento de inscrição, 
        arcando com as consequências de eventuais erros e/ou do não preenchimento de quaquer campo daquele campo.`,
        'A inscrição no Processo Seletivo implica, deste logo, o reconhecimento e a tácita aceitação, pelo candidato, das condições estabelecidas.',
        'Não será admitida, sob nenhuma hipótese, complementação documental fora do prazo de inscrição.',
        'Para a investidura do cargo é exigido a idade mínima de 18 anos.',
        '<span class="bold">O boleto referente a taxa de inscrição será enviado automaticamente para seu endereço de e-mail em até 24Hrs após o momento da inscrição. Caso passe esse período e ainda não tenha recebido, entre em contato conosco através do endereço <a href="mailto:suporte@ibcgp.org.br" class="bold link">suporte@ibcgp.org.br</a>.</span>'
      ]
    }
  }
}
</script>
<style lang="sass">
.bg-f2
  background-color: #f2f2f2 !important
li
  text-align: left
  list-style: decimal
  padding-left: 10px
  line-height: 16px
  margin-bottom: 10px
.bold
  font-weight: bold
.link
  color: #57b846 !important
</style>
